/**
 * PATH: packages/email-hub/src/feature/components/EmailContextMenu.tsx
 * FILE_ID: EMAILHUB-FEATURE-COMPONENTS-EMAILCONTEXTMENU-001
 * PURPOSE: Public frame for the canonical email context menu.
 * WHY: Tenants consume this stable path while domain behavior lives in
 *      typed email-context-menu modules.
 */
import {
  deriveAiSuggestion,
  derivePriorAllocationId,
  EmailContextMenuContent,
  EmailContextMenuDialogs,
  type EmailContextMenuProviderProps,
  useEmailContextMenuController,
} from './email-context-menu'

export { deriveAiSuggestion, derivePriorAllocationId }

export function EmailContextMenuProvider({
  children,
  ...options
}: EmailContextMenuProviderProps) {
  const controller = useEmailContextMenuController(options)
  const contextMenuNode = (
    <>
      <EmailContextMenuContent controller={controller} />
      <EmailContextMenuDialogs controller={controller} />
    </>
  )

  return <>{children({ handleContextMenu: controller.handleContextMenu, contextMenuNode })}</>
}
